export { default } from './StandardEndpage';
export type { Props as StandardEndpageProps } from './StandardEndpage';
